import * as React from "react";
import { NavLink } from "react-router-dom";
import { NavItem, Tooltip } from "reactstrap";

class SideBarNavItem extends React.Component<
  {
    navId: string;
    to: string;
    title: string;
    icon: React.ReactElement<any>;
  },
  { tooltipOpen: boolean }
> {
  state = {
    tooltipOpen: false
  };

  // Toggle tooltip
  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  };
  render() {
    const { navId, to, title, icon } = this.props;
    return (
      <NavItem id={"Tooltip-" + navId}>
        <NavLink to={to}>
          {icon}
          &nbsp;&nbsp;&nbsp;&nbsp;<span>{title}</span>
        </NavLink>
        <Tooltip
          placement="right"
          className="nav-tooltip"
          isOpen={this.state.tooltipOpen}
          target={"Tooltip-" + navId}
          toggle={this.toggle}
        >
          {title}
        </Tooltip>
      </NavItem>
    );
  }
}

export default SideBarNavItem;



// WEBPACK FOOTER //
// ./src/Components/Sidebar/SideBarNavItem.tsx